<div class="main-verifyOtp">
    <div class="verifyOtp-container">
        <div class="verifyOtp-card card-modern">
            <!-- Logo Section -->
            <div class="logo-section">
                <div class="logo-icon">
                    <img src="/assets/img/logo-no-bg.png" alt="" />
                </div>
            </div>

            <!-- Content Section -->
            <div class="content-section">
                <div>
                    <h1 class="welcome-title">Verification Code</h1>
                    <p class="verifyOtp-description">
                        We've sent a verification code to
                        <span class="email-text">{{ email | emailHide }}</span>
                        Please enter it below.
                    </p>
                </div>

                <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
                    <div class="form-fields">
                        <div class="actions">
                            <div class="otp-container">
                                <input
                                    *ngFor="
                                        let ctrl of otpForm.controls;
                                        let i = index
                                    "
                                    type="number"
                                    maxlength="1"
                                    class="otp-item"
                                    inputmode="numeric"
                                    [formControlName]="i"
                                    #otpInput
                                    (input)="onOtpInput($event, i)"
                                    (keydown)="onOtpKeyDown($event, i)"
                                    (paste)="onOtpPaste($event)"
                                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                />
                            </div>
                            <div class="resend-container">
                                <img src="/assets/img/resend-icon.svg" />
                                <button
                                    type="button"
                                    (click)="resendOtp()"
                                    class="resend-otp-btn"
                                >
                                    Resend
                                </button>
                            </div>
                            <button
                                class="verify-otp-btn"
                                [disabled]="isLoading$ | async"
                                (click)="verifyOtp()"
                            >
                                <span *ngIf="!isAuthLoading">Verify Now</span>
                                <span *ngIf="isAuthLoading">Verifying...</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
